import Vue from 'vue';
import Vuex from 'vuex';
import AppStore from './modules/AppStore';
import CategoriesStore from './modules/CategoriesStore';
import YourDataStore from './modules/YourDataStore';
import Authentication from './modules/Authentication';
import UserManagementStore from './modules/UserManagementStore';
import SegmentMeasureStore from './modules/SegmentMeasureStore'
import UserSettingStore from './modules/UserSettingStore'
import CohortStore from './modules/CohortStore'
import ConfigStore from './modules/ConfigStore'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        AppStore,
        Authentication,
        CategoriesStore,
        YourDataStore,
        UserManagementStore,
        SegmentMeasureStore,
        UserSettingStore,
        CohortStore,
        ConfigStore
    }
});
